import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import { deletePartner } from "../../../redux/CustomerReducer";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useDispatch } from "react-redux";
// import Swal from "sweetalert2";
import Swal from "sweetalert2";
//import { getUsers, verifyInvestor } from "../../../redux/CustomerReducer";
// import './UserDataAdmin.css'
//import { getInvestors } from "../../../redux/CustomerReducer";
import { RiDeleteBin6Line } from "react-icons/ri";

import axios from "axios"
import { SERVERURL } from "../../../ServerUrl";
import { useState } from "react";
import { useEffect } from "react";

import { useSelector } from "react-redux";
import EditAmbassadorDrawer from "../EditAmbassadorDrawer/EditAmbassadorDrawer";


export default function InvestorsData(props) {
 
 

  const [deleteVeh, setDeleteVeh] = useState(0);
  const [filtered2, setFiltered2] = useState([]);
  const [Index, setIndex] = useState();
  const [flag, setFlag] = useState();
  const [alertIndex, setAlertIndex] = useState();
  const dispatch = useDispatch();

  const updateFilteredData = () => {
    if (props.driverData) {
      const newFilteredData = props.driverData.filter(
        (item) =>
          item.verified === false &&
          item.verifieduser === true &&
          item.category === "investor"
      );
      setFiltered2(newFilteredData);
    }
  };



  const verifyClicked = async (index, id, row) => {
    console.log(index, id); //mongoid, array index
    console.log(row); //that particular object
  
    Swal.fire({
      title: 'Are you sure to verify ' + row.fullName + '?',
      text: '',
      icon: 'info', // Change 'alert' to 'info' for the icon
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, Verify it!'
    }).then(async (result) => { // Add 'async' before (result)
      if (result.isConfirmed) {
        try {
          const token = localStorage.getItem('token'); 
          const headers = {
            'Authorization': `Bearer ${token}`, // Corrected header format
          };
          const response = await axios.post(`${SERVERURL}/api/v1/verifySpecialUser`,{id:index}, {
            headers: headers, // Include the headers object in the request configuration
          });
    
              if(response.data.success === true)
              {
               
            // Update the state or perform any action on successful verification
            Swal.fire(
              '',
              'Verification Done!',
              'success'
            );


            setDeleteVeh(2);
            let zz = filtered2.filter((item) => item.fullName !== row.fullName);
            setFiltered2(zz);
          }
          else
          {
            if(response.data.success === false)
            {
              Swal.fire(
                '',
                response.data.message,
                'error'
              )
            }

          }
        } catch (error) {
          console.log("response 4", error.response)
          if (error.response.data.message) {
            console.error(error.response);
            Swal.fire({
              title: "",
              text: error.response.data.message,
              icon: 'error', // Change 'Error' to 'error' for the icon
              showCancelButton: true,
              cancelButtonColor: '#d33',
            })
          }
        }
      }
    });
  
    setAlertIndex(id); // Setting alert index
  };
  useEffect(() => {
    // When props.driverData changes, update the filtered data
    updateFilteredData();
  }, [props.driverData]);

//search left


  return (
    <div>
<table className="admin-table">
  <thead>
    <tr>
      <th>
        Name
      </th>
      <th>
        Title
      </th>
      <th>
        Email
      </th>
      <th>
        Location
      </th>
      <th>
        Twitter
      </th>
      <th>
        LinkedIn
      </th>
      <th>
        Phone
      </th>
      <th>
        Verification
      </th>
    </tr>
  </thead>
  <tbody>
    {filtered2.map((row, idx) => (
      <tr key={row.fullName}>
        <td className="admin-table-strong">
          {row.fullName}
        </td>
        <td>
          {row.title}
        </td>
        <td>
          {row.email}
        </td>
        <td>
          {row.location}
        </td>
        <td>
          <a href={row.twitter} className="admin-table-link" target="_blank" rel="noopener noreferrer">
            Link here
          </a>
        </td>
        <td>
          <a href={row.linkedIn} className="admin-table-link" target="_blank" rel="noopener noreferrer">
            Link here
          </a>
        </td>
        <td>
          {row.phone}
        </td>
        <td>
          <span className="admin-action admin-action-view" onClick={() => verifyClicked(row._id, idx, row)}>
            Verify
          </span>
        </td>
      </tr>
    ))}
  </tbody>
</table>


    </div>
    




    
  );
}
